import React, {useEffect, useState} from 'react';
import {PlusCircleIcon, TrashIcon} from "@heroicons/react/24/solid";
import _ from 'lodash'
import {getSinglePod, searchPods} from "../../services/pod-data-service";

const PodCardList = ({selectedPod, setSelectedPod}) => {
    const [searchText, setSearchText] = useState('');
    const [podsList, setPodsList] = useState([]);

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    const handleSelectPod = async (pod) => {
        const existingPod = await getSinglePod(pod.id);
        const podData = existingPod.data();
        podData.id = existingPod.id;

        setSelectedPod(podData);
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                const podsListResult = await searchPods(searchText);
                setPodsList(podsListResult);
                setSelectedPod(podsListResult[0]);
            }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchText]);

    return (
        <>

            <div className="flex justify-between w-96 m-2">
                <input type="text" placeholder="Search"
                       id="text"
                       name="text"
                       value={searchText}
                       onChange={handleSearchText}
                       className="h-12 w-full border border-gray-500 p-4 rounded mr-2"/>

                <button
                    onClick={() => handleClearSearch()}
                    className="rounded flex items-center justify-center border-gray-500 border bg-white text-gray-500 h-12 hover:bg-gray-500 hover:text-white">
                    <div className="p-4">
                        <TrashIcon className="h-6 w-6"/>
                    </div>
                </button>
            </div>

            <div className="flex flex-wrap pt-4">
                {podsList?.map((pod, index) => (
                    <a key={index}
                       className="shadow-lg bg-white flex items-center justify-center text-gray-600 hover:bg-neutral-400 hover:text-white rounded m-2 p-8 h-64 w-64 cursor-pointer"
                       href={`/pods/${pod?.id}/edit`}>
                        <div className="text-3xl">
                            {pod?.displayLabel}
                        </div>
                    </a>
                ))}

                <a className="shadow-lg bg-white flex items-center justify-center text-gray-600 hover:bg-neutral-400 hover:text-white rounded m-2 p-8 h-64 w-64 cursor-pointer"
                   href="/pods/add-pods">
                    <div className="">
                        <PlusCircleIcon className="h-10 w-10"/>
                    </div>
                </a>
            </div>

        </>
    )
}

export default PodCardList
